var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 79,
    viewBox: "0 0 66 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9091 3.42969V34.2884C25.9091 35.0871 26.7992 35.5635 27.4638 35.1205L35.1726 29.9813C35.5085 29.7574 35.9461 29.7574 36.282 29.9813L43.9908 35.1205C44.6553 35.5635 45.5455 35.0871 45.5455 34.2884V3.42969M11.1818 59.0661C9.01187 59.0661 6.93079 59.9281 5.3964 61.4624C3.86201 62.9968 3 65.0779 3 67.2479M3 67.2479C3 69.4178 3.86201 71.4989 5.3964 73.0333C6.93079 74.5677 9.01187 75.4297 11.1818 75.4297H65.1818M3 67.2479V11.6115C3 9.44155 3.86201 7.36048 5.3964 5.82609C6.93079 4.2917 9.01187 3.42969 11.1818 3.42969H60.9091C61.4614 3.42969 61.9091 3.8774 61.9091 4.42969V58.089C61.9091 58.6412 61.4614 59.089 60.9091 59.089H11.1556M60.2727 59.0661C58.1028 59.0661 56.0217 59.9281 54.4873 61.4624C52.9529 62.9968 52.0909 65.0779 52.0909 67.2479C52.0909 69.4178 52.9529 71.4989 54.4873 73.0333C56.0217 74.5677 58.1028 75.4297 60.2727 75.4297",
    stroke: "url(#paint0_linear_3_814)",
    strokeWidth: 5.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_814",
    x1: 34.0909,
    y1: 3.42969,
    x2: 34.0909,
    y2: 75.4297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.abc78359a860b344c1f8046862cc630d.svg";
export { ForwardRef as ReactComponent };